<template>
  <section>
    <div class="container">
      <h2 class="pb-2">
        {{ titulo != null ? titulo : this.title != null ? this.title : "" }}
      </h2>
      <div
        v-if="!items"
        class="row row-cols-1 g-4"
        v-bind:class="[
          columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3',
        ]"
      >
        <div
          class="col"
          v-for="n in parseInt(columnas) > 0 ? parseInt(columnas) : 3"
          v-bind:key="n"
        >
          <div class="card loading-card {{n}}">
            <div class="card-body rounded d-flex align-items-center"></div>
          </div>
        </div>
      </div>
      <div
        class="row row-cols-1 g-4"
        v-bind:class="[
          columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3',
        ]"
      >
        <div class="col" v-for="(el, i) in items" :key="i">
          <div class="card">
            <div class="card-body rounded d-flex card-hover align-items-center">
              <div
                v-if="!el.link"
                class="dropdown-body icon-square d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-2 text-ptn-color-gsj-brand"
                @click="toggleDropdown(el)"
              >
                <i
                  class="material-symbols-outlined"
                  v-bind:class="[el.desc ? 'fs-1' : '']"
                >
                  {{ el.active ? "expand_less" : "expand_more" }}
                </i>
              </div>
              <div>
                <div v-if="el.link" class="card-title h4">
                  <a
                    :href="el.link"
                    target="_blank"
                    class="pt-3 text-ptn-color-gsj-brand"
                  >
                    {{ el.title }}
                  </a>
                </div>
                <div v-else class="card-title h4 text-ptn-color-gsj-brand">
                  <a :href="el.link">
                    {{ el.title }}
                  </a>
                </div>

                <div v-if="el.desc.listado && el.active">
                  <ul class="list-unstyled">
                    <li v-for="(item, index) in el.desc.listado" :key="index">
                      <div class="fac-a">
                        <span
                          class="material-symbols-outlined text-ptn-color-gsj-brand fac-span"
                        >
                          description
                        </span>
                        <a
                          :data-bs-target="
                            '#exampleModalToggle-' + i + '-' + index
                          "
                          data-bs-toggle="modal"
                          style="cursor: pointer"
                          class=""
                        >
                          {{ item.title }}
                        </a>

                        <div
                          class="modal fade"
                          :id="'exampleModalToggle-' + i + '-' + index"
                        >
                          <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">{{ item.title }}</h5>
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <p>{{ item.contenido.desc }}</p>
                                <img
                                  :src="item.contenido.img"
                                  class="mx-auto d-block img-fluid my-3"
                                />
                                <a
                                  type="button"
                                  class="btn btn-secondary me-3 my-3"
                                  target="_blank"
                                  :href="item.contenido.linkTramite"
                                >
                                  Link al Trámite
                                </a>
                                <a
                                  type="button"
                                  class="btn btn-secondary"
                                  target="_blank"
                                  :href="item.contenido.mapaDoc"
                                >
                                  Acceso a Mapa Documental
                                </a>
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Cerrar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <p
                  class="card-text"
                  v-else-if="el.desc && el.active"
                  v-html="el.desc"
                ></p>
                <p class="card-text" v-else-if="el.active">
                  Contenido en construcción
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const axios = require("axios");
export default {
  name: "DropdownComponent",
  props: {
    titulo: String,
    subtitulo: String,
    columnas: String,
    filtros: Object,
    data: Object,
  },
  data() {
    return {
      hash: "DROPC",
      items: null,
      title: null,
      desc: null,
    };
  },
  methods: {
    toggleDropdown(el) {
      el.active = !el.active;
    },
  },
  mounted() {
    if (this.data == null) {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.tipo = this.hash;
      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.items = response.data ? response.data.items : null;
          this.title = response.data ? response.data.title : null;
          this.desc = response.data ? response.data.desc : null;
          this.items.forEach((item) => (item.active = false));
          localStorage.setItem(this.hash, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Linea");
            if (localStorage.getItem(this.hash)) {
              console.log("Cargando elementos de cache para " + this.hash);
              var resp = JSON.parse(localStorage.getItem(this.hash));
              this.items = resp.data ? resp.data.items : null;
              this.title = resp.data ? resp.data.title : null;
              this.desc = resp.data ? resp.data.desc : null;
            }
          }
        });
    } else {
      this.items = this.data;
    }
  },
};
</script>

<style>
.dropdown-body {
  cursor: pointer;
}
</style>
